<template>
  <div class="page_warp">
    <div class="top_content">
      <div class="top_input">
        <el-input placeholder="请输入"></el-input>
      </div>
      <div class="search_btn" @click="getData">查询</div>
    </div>
    <div class="bottom_content">
      <div class="table_container" v-bind:id="tableId">
        <el-table
          v-bind:data="tableData"
          stripe
          border
          style="width: 100%"
          v-bind:max-height="tableHeight"
          v-bind:header-cell-style="{
            textAlign: 'center',
            color: '#333333',
            background: '#F5F5F5',
          }"
          v-bind:cell-style="{ textAlign: 'center' }"
          empty-text="暂无数据"
        >
        <el-table-column prop="logId" label="序号" width="90"></el-table-column>
        <el-table-column prop="userLgname" label="操作用户" width="150">
            <template #default="scope">
              <p>{{ scope.row.userLgname }}</p>
              <p>{{ scope.row.logUserName }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="logCreTime" label="IP与时间" width="240">
            <template #default="scope">
              <p>IP：{{ scope.row.logIp }}</p>
              <p>用时:{{ scope.row.logRespTime }}</p>
              <p>操作时间:{{ scope.row.logCreTime }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="logOper" label="操作内容" width="120">
             <template #default="scope">
              <p class="myNote">{{ scope.row.logOper }}</p>
             
            </template>
          </el-table-column>
          <el-table-column prop="logParam" label="操作数据" >
            <template #default="scope">
              <p class="myNote" :title="scope.row.logParam">{{ scope.row.logParam }}</p>
            </template>
          </el-table-column>
          <el-table-column
            prop="logCreTime"
            label="创建时间"
          ></el-table-column>
          <el-table-column label="操作">
            <template #default="scope">
          
              <span
                class="default_color pointer m-right10"
                v-on:click="detail(scope.row.logId)"
                >详情</span
              >
           
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="flex flex-y-center flex-x-center">
        <el-config-provider :locale="locale">
          <el-pagination
            background
            v-model:currentPage="page"
            v-model:page-size="pageSize"
            :page-sizes="[5, 10, 15, 20]"
            layout="sizes, prev, pager, next, total, jumper"
            :total="totalCount"
            @size-change="getData"
            @current-change="getData"
          />
        </el-config-provider>
      </div>
    </div>


    <Detail ref="detailRef" v-if="isDetail" @getData="getData" />

  </div>
</template>

<script>
import {
  computed,
  defineComponent,
  reactive,
  toRefs,
  nextTick,
  onMounted,
  getCurrentInstance,
} from "vue";
import { useStore } from "vuex";
import { apiObj } from "@/config/api";
import Detail from "./components/detail";
import zhCn from "element-plus/es/locale/lang/zh-cn";
export default defineComponent({
  components: {  Detail },
  name: "systemLogManage",
  setup() {
    const store = useStore();
    const { proxy } = getCurrentInstance();

    const data = reactive({
      tableId: "systemLogManageTable",
      page: 1,
      pageSize: 10,
      searchWord: "",
      totalCount: 0,
      tableData: [],
      tableHeight: 0,
      isDetail: false,
      locale: zhCn,
    });
    onMounted(() => {
      console.log(store.state.userInfo);
      nextTick(() => {
        data.tableHeight =
          document.querySelector(
            ".bottom_content .table_container#" + data.tableId
          ).offsetHeight - 40;
        getData();
      });
      window.onresize = () => {
        nextTick(() => {
          var offsetHeight = document.querySelector(
            ".bottom_content .table_container#" + data.tableId
          ).offsetHeight;
          if (offsetHeight <= 0) {
            return false;
          }
          data.tableHeight = document.querySelector(
            ".bottom_content .table_container#" + data.tableId
          ).offsetHeight;
        });
      };
    });
    //获取列表数据
    const getData = async () => {
      let params = {
        searchWord: data.searchWord,
        page: data.page,
        limit: data.pageSize,
      };
      const r = await proxy.$http.get(apiObj.logList, params);
      console.log(r);
      if (r.code === 0) {
        data.tableData = r.rows;
        data.totalCount = r.total;
      }
    };
    // 详情
    const detail=(id)=>{
      data.isDetail=true;
      nextTick(()=>{
        proxy.$refs.detailRef.init(id);
      })
    }

    
  

    return {
      ...toRefs(data),
      getData,
      detail
      
    };
  },
});
</script>

<style scoped>
.page_warp {
  width: 100%;
  height: 100%;
}
.myNote{
  display:-webkit-box;
  text-overflow:ellipsis;
  overflow:hidden;
  -webkit-line-clamp: 3;
  -webkit-box-orient:vertical;
}
</style>
